const utils = require('frontend-controller/lib/utils')

module.exports = {
    model: {
        triggerComponentIndex: null,
    },

    methods: {
        async submitOtherPropertiesForms(triggerComponentIndex, submitDone = false){
            // prevent submit cascades
            if(this.model.triggerComponentIndex){
                return
            }
            if(!triggerComponentIndex){
                return
            }
            this.model.triggerComponentIndex = triggerComponentIndex

            const propertiesForms = []
            this.find('templates_crew_profile_employees_propertiesForm', propertiesForm => {
                if(propertiesForm.componentIndex && this.model.triggerComponentIndex !== propertiesForm.componentIndex) {
                    propertiesForms.push(propertiesForm)
                }
            })

            // submit others
            const {nrOfResolves} = await utils.promise.resolveAll(this, propertiesForms.map(propertiesForm => propertiesForm.submit()))
            submitDone = submitDone || nrOfResolves > 0

            delete this.model.triggerComponentIndex

            // show statusPanel myself
            let panelMessage
            if(submitDone){
                panelMessage = 'status.done.save'
            } else {
                panelMessage = 'status.nothingChanged'
            }

            let statusController
            if(panelMessage && (statusController = getComponent('statusController'))){
                statusController.addPanel(panelMessage)
            }

            // hide ProfileManagement afterward
            let modal
            this.closest('base_modal_modal', c => modal = c)
            if(modal){
                modal.decide(false)
            }
        }
    },

    handlers: [{
        name: 'onSubmitDone',
        componentClass: 'templates_crew_profile_employees_propertiesForm',
        handle(callerComponent, nodeData, insertPerformed){
            this.submitOtherPropertiesForms(callerComponent.componentIndex, true)
        }
    },{
        name: 'onSubmitNothing',
        componentClass: 'templates_crew_profile_employees_propertiesForm',
        handle(callerComponent, nodeData, insertPerformed){
            this.submitOtherPropertiesForms(callerComponent.componentIndex, false)
        }
    }]
}